// @flow

import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useUpdate, useRefresh, useNotify, useTranslate } from 'react-admin';
import { Tooltip, Button, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MoveIcon from '@material-ui/icons/OpenWith';
import DoneIcon from '@material-ui/icons/Done';

const useStyles = makeStyles({
	button: {
		minWidth: 0,
	},
	value: {
		display: 'inline-block',
		textAlign: 'center',
		width: 40,
	}
});

const OrderingField = ({ resource, source, record = {} }) => {
	const [open, setOpen] = useState(false);
	const [value, setValue] = useState(record[source]);
	const refresh = useRefresh();
	const notify = useNotify();
	const translate = useTranslate();
	const classes = useStyles();

	const [updateOrdering, { loading }] = useUpdate(
		resource,
		record.id,
		{ ordering: value },
		record,
		{
			onSuccess: () => {
				refresh();
				notify(translate('ra.notification.ordering_updated'));
			},
			onFailure: error => notify(translate('ra.notification.http_error'), 'warning'),
		}
	);

	const handleClick = () => setOpen(true);

	const handleConfirm = () => {
		updateOrdering();

		setOpen(false);
	};

	if(open || loading) {
		return (
			<Fragment>
				<TextField className={classes.value} type="number" size="small" margin="none" value={value} onChange={e => setValue(e.target.value)} />
				<Button className={classes.button} onClick={handleConfirm} size="small">
					<Tooltip title={translate('ra.action.save')}>
						<DoneIcon fontSize="small" />
					</Tooltip>
				</Button>
			</Fragment>
		);
	} else {
		return (
			<Fragment>
				<div className={classes.value}>{record[source]}</div>
				<Button className={classes.button} label={translate('ra.action.bulk_disable_state')} onClick={handleClick} size="small">
					<Tooltip title={translate('ra.action.change_ordering')}>
						<MoveIcon fontSize="small" />
					</Tooltip>
				</Button>
			</Fragment>
		);
	}
};

OrderingField.propTypes = {
	label: PropTypes.string,
	record: PropTypes.object,
	source: PropTypes.string.isRequired,
};

export default OrderingField;